export default __webpack_public_path__ + "static/media/taming.8e407da5.png";